import { render, staticRenderFns } from "./Gachita.vue?vue&type=template&id=6bff8abf&"
import script from "./Gachita.vue?vue&type=script&lang=js&"
export * from "./Gachita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports